export default "<p>stacked-column-chart works!</p>\r\n"